import { useQuery } from "@tanstack/react-query";
import i18next from "i18next";
import { getCustomerWishlist } from "../../api/apiCustomers";

export const useGetCustomerWishlist = (id) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["customer-wishlist", id, i18next.language],
        queryFn: () => getCustomerWishlist(id),
        enabled: !!id,
    });

    const root = data?.data;
    const items = Array.isArray(root) ? root : (Array.isArray(root?.data) ? root.data : []);

    return { isLoading, error, items, refetch };
};
